import React from 'react';

// Static image stand-in for VideoEmbed's chrome={true} framing, used on a
// use case whose hero has a screenshot/mockup instead of a recorded
// walkthrough. Mirrors VideoPlaceholder's card treatment (rounded card,
// thick border, caption strip below) so it reads consistently with every
// other use case's hero media -- swap this out for a real
// <VideoEmbed url={...} chrome /> the moment a walkthrough exists (see
// useCases.js).
const HeroImagePreview = ({
  src,
  // Optional: a separate, shorter/narrower render of the same content for
  // phones. The wide desktop screenshot (aspectClassName, e.g. 16/7.8)
  // can't just be cropped taller for mobile -- the chat bubbles are pushed
  // hard left/right, so a narrower crop of the SAME image would cut one
  // side's messages off entirely. mobileSrc is instead a whole separate
  // render: same conversation, redesigned as a taller/narrower frame with
  // bigger text and tighter bubble spacing, since a phone shows this at a
  // much smaller physical size and needs the text to make up more of the
  // frame to stay legible. When omitted, `src` is used at every size (old
  // single-image behavior).
  mobileSrc,
  alt = '',
  caption,
  className = '',
  aspectClassName = 'aspect-video',
  // Shape for the mobile render above -- only meaningful alongside
  // mobileSrc. Defaults to aspectClassName if not given.
  mobileAspectClassName,
}) => {
  const hasMobileVariant = Boolean(mobileSrc);

  return (
    <div className={className}>
      <div className="overflow-hidden rounded-xl border-[3px] border-black/70 bg-white shadow-2xl ring-1 ring-white/20">
        {hasMobileVariant && (
          <div className={`relative sm:hidden ${mobileAspectClassName || aspectClassName}`}>
            <img
              src={mobileSrc}
              alt={alt}
              className="h-full w-full object-cover"
            />
          </div>
        )}

        <div
          className={`relative ${aspectClassName} ${hasMobileVariant ? 'hidden sm:block' : ''}`}
        >
          <img
            src={src}
            alt={alt}
            className="h-full w-full object-cover"
          />
        </div>

        {caption && (
          <p className="border-t-[3px] border-black/70 bg-gray-100 py-2 text-center text-sm font-medium text-black/70">
            {caption}
          </p>
        )}
      </div>
    </div>
  );
};

export default HeroImagePreview;
